<template>
    <div class="wrapper">
        <div class="flex">
            <div class="category">{{ machine.category }}</div>
            <div class="year">{{ machine.year }}</div>
        </div>
        <div class="name">{{ machine.title }}</div>
        <div class="badges">
            <div class="badge sold" v-if="machine.sold">Sold</div>
            <component
                v-if="machine.alert"
                :is="machine.alert.href ? 'a' : 'div'"
                :href="machine.alert.href"
                target="_blank"
                rel="noopener"
                class="badge"
                :style="{ background: machine.alert.color || 'rgb(255, 183, 16)' }"
            >{{ machine.alert.text }}</component>
        </div>
        <div class="price">{{ formatPrice(machine.price) }}</div>
        <div class="characteristics">
            <div class="item"><span>SKU:</span> {{ machine.sku }}</div>
            <div class="item" v-if="machine.make"><span>Manufacturer:</span> {{ machine.make }}</div>
            <div class="item" v-if="machine.year"><span>Year of make:</span> {{ machine.year }}</div>
            <div class="item" v-if="machine.category"><span>Category:</span> {{ machine.category }}</div>
            <div class="item"><span>Availability:</span> {{ machine.sold ? 'Sold' : 'Available' }}</div>
            <a class="item link" v-if="machine.images_external" :href="machine.images_external" target="_blank" rel="noopener">
                More photos
                <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.74 4.42L9.02 0.81L9.86 0L14.58 4.59L15 5L14.58 5.4L9.86 10L9.02 9.18L12.74 5.57L0 5.57L0 4.42L12.74 4.42Z" fill="#050505" fill-rule="evenodd"/>
                </svg>
            </a>
        </div>
        <div class="buttons">
            <ButtonOrange class="contact" @click="$scrollTo('footer')">Get in Touch!</ButtonOrange>
            <button class="share" v-if="machine.share_string" @click="share">{{ copied ? 'Copied!' : 'Share' }}</button>
        </div>
    </div>
</template>

<script>
import ButtonOrange from '../UI/ButtonOrange.vue';
import { formatPrice } from './price';
export default {
    components: {
        ButtonOrange,
    },
    props: {
        machine: { type: Object, required: true },
    },
    data() {
        return {
            copied: false,
        };
    },
    methods: {
        formatPrice,
        async share() {
            const text = `${this.machine.share_string}\n\n${window.location.href}`;
            try {
                if (navigator.share) {
                    await navigator.share({ title: this.machine.title, text });
                    return;
                }
                await navigator.clipboard.writeText(text);
                this.copied = true;
                setTimeout(() => (this.copied = false), 2000);
            } catch (e) {
                // пользователь закрыл окно «Поделиться» — ничего не делаем
            }
        },
    },
}
</script>

<style scoped>
.flex{
    display: flex;
    justify-content: space-between;
    gap: 16px;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    margin-bottom: 16px;
}
.name{
    color: rgb(5, 5, 5);
    font-size: 32px;
    font-weight: 500;
    line-height: 140%;
    padding-bottom: 15px;
}
.badges{
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}
.badges:not(:empty){
    padding-bottom: 16px;
}
.badge{
    padding: 4px 12px;
    border-radius: 81px;
    color: rgb(255, 255, 255);
    font-size: 13px;
    font-weight: 500;
    line-height: 140%;
    text-transform: uppercase;
}
.badge.sold{
    background: rgb(5, 5, 5);
}
.price{
    color: rgb(5, 5, 5);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    padding-bottom: 24px;
}
.characteristics{
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding: 24px 0;
    border-top: 1px solid rgb(222, 230, 234);
    border-bottom: 1px solid rgb(222, 230, 234);
    margin-bottom: 24px;
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
}
.characteristics span{
    color: rgb(85, 98, 114);
}
.characteristics .link{
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgb(5, 5, 5);
    text-decoration: underline;
    text-decoration-color: rgb(255, 183, 16);
    text-underline-offset: 4px;
}
.buttons{
    display: flex;
    gap: 16px;
}
.buttons .contact{
    flex: 1;
}
.share{
    height: 44px;
    padding: 0 28px;
    border-radius: 32px;
    border: 2px solid rgb(222, 230, 234);
    background: rgb(255, 255, 255);
    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: border-color 0.3s;
}
.share:hover{
    border-color: rgb(255, 183, 16);
}
@media (max-width: 768px) {
    .name{
        font-size: 24px;
    }
}
</style>
